import React from 'react';
import styled from 'styled-components';

import { Attachment, Emoji } from 'components/composer/shared/editor_action_buttons_new';
import { AITextCompletionButtons } from 'components/text_editor_new/components/controls/ai_text_rewrite_controls';
import FromField from './from_field';
import { Header, HeaderText } from 'components/composer/shared/composer_new';
import { OpenerButton } from 'components/common/dropdown_menu';
import { Separator } from 'components/composer/shared/editor_controls_new';
import ToField from './to_field';

export default function AISMSHeader({ editorProps, isInvalidNumber, phoneNumbers }) {
  return (
    <Container>
      <Header>
        <Left>
          <HeaderText color="green400">SMS</HeaderText>
          <ToField isInvalidNumber={isInvalidNumber} phoneNumbers={phoneNumbers} />
        </Left>
        <Right>
          <SmallerFromField />
        </Right>
      </Header>
      <Formatting>
        <AITextCompletionButtons />
        <Separator />
        <Emoji {...editorProps} />
        <Attachment alwaysShow />
      </Formatting>
    </Container>
  );
}

const Container = styled.div``;
const Left = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
`;
const Right = styled.div`
  align-items: center;
  display: flex;
`;
const Formatting = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: flex-end;
`;
const SmallerFromField = styled(FromField)`
  ${OpenerButton} {
    min-height: 30px;
    padding: 6px 12px;
  }
`;
